import { IState } from "../reducers";
import { IFinancialRolesState } from "./financial-roles.reducer";
import { IFinancialRoles } from "../../common/services/contracts/projectservice-functions.contract";

export const getFinancialRolesState = (store: IState): IFinancialRolesState => store.financialRoles;
export const getFinancialRoles = (store: IState): IFinancialRoles[] => getFinancialRolesState(store).financialRoles;
export const getFinancialRolesLoading = (store: IState): boolean => getFinancialRolesState(store).loading;
export const getFinancialRolesLoaded = (store: IState): boolean => getFinancialRolesState(store).loaded;
export const getFinancialRolesError = (store: IState): string => getFinancialRolesState(store).error;
